import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var form16Res;
export const form16Todo = createAsyncThunk('form16', async (data) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'hr/form_16_data',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "device_token": user_id.vdevice_token,
                "ibusiness_area_id": user_id.ibusiness_area_id,
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return form16Res = res.data
    } catch (error) {
        return form16Res = error.response.data
    }
})